<!--<div *ngIf="!showClauses && !showWarring" class="grid md:grid-cols-2">-->
<div class="flex flex-col mb-10">
  <div *ngFor="let field of ksfPriceResult.fields; let i = index">
    <ng-container *ngIf="field.type.isList && field.type.kind !== 'Complex'">
      <ng-container *ngIf="i == 0 || showFieldIndexArray[i - 1]">
        <div class="font-syne text-2xl font-semibold mb-5">
          {{ field.name }}
        </div>

        <div class="mb-6 w-56">
          <app-dropdown
            [disableDropdown]="ksfPriceLoading"
            [selectedValue]="selectedFieldsValues[i]?.valueText ?? ''"
            [placeholder]="'Vælg ' + field.name"
            [options]="field.type.selectList"
            (output)="dropdownOutput($event, 'fields', i)"
          ></app-dropdown>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div>
    <button
      *ngIf="!ksfPriceLoading && allFieldsSet()"
      (click)="validateExtraInfo()"
      type="button"
      class="py-3 px-4 shadow-lg font-inter inline-flex items-center gap-x-1 text-sm rounded-full border border-transparent bg-teal-450 text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none w-auto"
    >
      Næste
    </button>
    <div class="m-5" *ngIf="ksfPriceLoading">
      <lib-loading-indicator size="10"></lib-loading-indicator>
    </div>
  </div>
</div>
